var ClientHeadAssetIncluder = /** @class */ (function () {
    function ClientHeadAssetIncluder(docRef) {
        this.docRef = docRef;
    }
    ClientHeadAssetIncluder.prototype.includeCss = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var link = _this.docRef.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            link.onload = function () {
                resolve();
            };
            link.onerror = function () {
                reject();
            };
            _this.docRef.head.appendChild(link);
            return Promise.resolve();
        });
    };
    return ClientHeadAssetIncluder;
}());
export { ClientHeadAssetIncluder };
